// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
export const formatNotes = (notes?: string | null, defaultValue = '-') =>
  notes === '' || notes == null ? defaultValue : notes;
